.az{flex:1;}